module.exports = __webpack_public_path__ + "img/free04_800x400.96cbc7a2.jpg";